import { ref } from 'vue'
import Isotope from '@/isotope-layout'
import usePreloadImages from '@/Shared/usePreloadImages.js'

/**
 * Isotopeを実行
 * @param {{
 * isotopeContainer: HTMLElement,
 * isotopeItem: String,
 * data: Object[],
 * key: String,
 * category?: String,
 * callback?: Function,
 * }}
 * 以下の引数をオブジェクトに格納
 * @param isotopeContainer isotopeの各アイテムを囲むコンテナー要素（例：containerRef.value）
 * @param isotopeItem isotopeの各アイテムのクラス名（例：'.isotope-item'）
 * @param data 元データ（例：props.newsItems.data, props.booksInfo.dataなど）
 * @param key 元データから画像を取得するキー（例：newsThumb, bookThumb, brandImg, shopImgなど）
 * @param category カテゴリー（任意）
 * @param callback コールバック関数（任意）
 */

export default function useIsotope({ isotopeContainer, isotopeItem, data, key, category, callback }){
  const isotope = ref()
  
  const initIsotope = () => {
    isotope.value = new Isotope(isotopeContainer, {
      itemSelector: isotopeItem,
      masonry: { columnWidth: isotopeItem },
      percentPosition: true,
      transitionDuration: 0,
    })
    showIsotopeContainer()
    if(category) {
      changeCategory(category)
      callback()
    }
  }

  const showIsotopeContainer = () => {
    isotopeContainer.style.opacity = '1'
    setTimeout(() => {
      if (!isotopeContainer) return
      isotopeContainer.style.transitionDuration = '0s'
      isotopeContainer.style.transitionDelay = '0s'
    }, '0')
  }
  
  const changeCategory = (target) => {
    if (target === 'all') return
    isotope.value.arrange({
      filter: (item) => item.classList.contains('category-' + target),
    })
  }

  // usePreloadImagesを使って画像を読み込み後にinitIsotopeを実行
  usePreloadImages({
    data: data,
    key: key,
    callback: initIsotope,
  })
}